import { ESTABLECIMIENTO_URL, ESTABLECIMIENTO_PASO4_URL, ESTABLECIMIENTOANTERIOR_PASO4_URL, PERSONA_URL } from '../config';
import axios from 'axios';

export const getEstablecimientos = async (params) => {
    const url = `${ESTABLECIMIENTO_URL}?`
        + `&departamentoId=${params.departamentoId == null ? '' : params.departamentoId}`
        + `&localidadId=${params.localidadId == null ? '' : params.localidadId}`
        + `&nivelEnsenanzaId=${params.nivelEnsenanzaId == null ? '' : params.nivelEnsenanzaId}`
        + `&cursoId=${params.cursoId == null ? '' : params.cursoId}`
        + `&turnoId=${params.turnoId == null ? '' : params.turnoId}`
        //+ `&esSeleccionable=${params.esSeleccionable === undefined ? '' : params.esSeleccionable ? 'true' : 'false'}`
        //+ `&esPrivado=${params.esPrivado === undefined ? '' : params.esPrivado ? 'true' : 'false'}`
        //+ `&palabraABuscar=${params.palabraABuscar === undefined ? '' : params.palabraABuscar}`
        ;
    const result = await axios.get(url);
    return result;
};

export const getEstablecimientosPaso4 = async (params) => {
    const url = `${ESTABLECIMIENTO_PASO4_URL}?`
        + `&departamentoId=${params.departamentoId == null ? '' : params.departamentoId}`
        + `&localidadId=${params.localidadId == null ? '' : params.localidadId}`
        ;
    const result = await axios.get(url);
    return result;
};

export const getEstablecimientosAnteriorPaso4 = async (params) => {
    const url = `${ESTABLECIMIENTOANTERIOR_PASO4_URL}?`
        + `&departamentoId=${params.departamentoId == null ? '' : params.departamentoId}`
        + `&localidadId=${params.localidadId == null ? '' : params.localidadId}`
        ;
    const result = await axios.get(url);
    return result;
};


export function getPersona(params) {
    const url = `${PERSONA_URL}?sexo=${params.sexo}&nroDocumento=${params.nroDocumento}`;
    const result = axios.get(url);
    return result;
};

